/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Relationship/view.blocks to change it.
import * as fromAggregate from 'Simple/Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Relationship({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/PracticeHub/People/Person/Relationship"
  
}) {
let personRelationshipTypeValueData = fromData.useDataFormat({ viewPath,
context: 'person',
path: 'relationship_type',
format: fromFormat.capitalize,
})
let constantData = 'Patient'
let aggregateData = fromAggregate.any(personRelationshipTypeValueData, constantData)
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral600}
 data="person.relationship_type"
 format="/Data/format.js capitalize"
 data="'Patient'"
 aggregate="/Simple/Data/aggregate.js any"
 text={aggregateData}
/>
{children}
</React.Fragment>)
}